import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import { authorizedGet, authorizedPost } from '../functions/AuthService';

export const useJobtrackBonus = (fecha, enabled = true) => {
    return useQuery({
        queryKey: ['bonus', 'jobtrack', fecha ?? 'actual'],
        enabled,
        queryFn: async () => {
            const response = await authorizedGet("/jobtrack/getbonus", fecha ? {fecha} : {});
            // console.log("Response: ", response.body.json());
            return await response.body.json();
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 15, //Keep it in memory for 15 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}

export const useSaveBonusPercentages = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const response = await authorizedPost("/jobtrack/bonus/savepercentages", payload);
            // console.log("Response: ", response.body.json());
            return await response.body.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['bonus', 'percentages'])
        }
    });
}

export const useGetSavedBonusPercentages = () => {
    return useQuery({
        queryKey: ['bonus', 'percentages'],
        queryFn: async () => {
            const response = await authorizedGet("/jobtrack/bonus/getpercentages");
            // console.log("Response: ", response.body.json());
            return await response.body.json();
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 60 * 24 * 7, //Keep it in memory for a week
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}